import React from 'react';
import { Box, Container, Typography } from '@mui/joy';
import NotesList from '../components/NotesList';

const NotesPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 3 }}>
        <Typography level="h1" component="h1" sx={{ mb: 3 }}>
          Notes Management
        </Typography>
        
        <NotesList />
      </Box>
    </Container>
  );
};

export default NotesPage; 